module.exports = __webpack_public_path__ + "static/media/simulationtrainingimg.1753b63c.png";